import React from 'react';
import classNames from 'classnames';

import './Label.scss';

const Label = ({ color, label }) => (
  <span
    className={
      classNames(
        'label',
        {
          [`label--${color}`]: color
        }
      )
    }
  >
    {label}
  </span>
);

export default Label;